(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cf-assistente"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('[data-cf-bot]');
    if (!root) return;

    const toggle = root.querySelector('[data-cf-bot-toggle]');
    const panel = root.querySelector('[data-cf-bot-panel]');
    const closeBtn = root.querySelector('[data-cf-bot-close]');
    const log = root.querySelector('[data-cf-bot-log]');
    const form = root.querySelector('[data-cf-bot-form]');
    const input = root.querySelector('[data-cf-bot-input]');
    const chips = root.querySelector('[data-cf-bot-chips]');

    const REGOLE = [
      { chiavi: ['campion', 'campionatur', 'provino', 'toccare'], risposta: 'Puoi richiedere fino a 3 campioni gratuiti: paghi solo 7 \u20ac di spedizione (8 \u20ac per isole e localit\u00e0 disagiate). Consegna indicativa in 24\u201372 ore lavorative.' },
      { chiavi: ['spedizion', 'consegna cost', 'quanto costa la spedizione', 'porto', 'trasporto', 'spese'], risposta: 'La spedizione costa 25 \u20ac per ordini sotto 600 \u20ac ed \u00e8 gratuita da 600 \u20ac in su, escluse isole e localit\u00e0 disagiate. Spediamo in tutta Italia.' },
      { chiavi: ['tempi', 'quanto tempo', 'quando arriva', 'quando ricevo', 'giorni'], risposta: 'Pavimenti e rivestimenti arrivano normalmente in 3\u201310 giorni lavorativi. Le porte richiedono 15\u201330 giorni lavorativi perch\u00e9 vengono configurate su misura. Ad agosto e dicembre i tempi possono allungarsi.' },
      { chiavi: ['mq', 'metri quadr', 'quanto ne serve', 'quantit', 'calcol', 'misura la stanza'], risposta: 'Calcola la superficie della stanza e aggiungi circa il 10% per tagli e scorta. Se ci mandi le misure dell\u2019ambiente ti aiutiamo a verificare il conteggio prima dell\u2019ordine: scrivi a <a href="mailto:casaforma.shop@gmail.com">casaforma.shop@gmail.com</a>.' },
      { chiavi: ['reso', 'restitu', 'recesso', 'rimborso', 'cambiare idea'], risposta: 'Sui prodotti standard hai 14 giorni di diritto di recesso, restituendo la merce integra nell\u2019imballo originale. I prodotti su misura o personalizzati, come le porte configurate, sono esclusi nei limiti di legge.' },
      { chiavi: ['pagament', 'carta', 'bonifico', 'contrassegno', 'paypal', 'klarna', 'come pago'], risposta: 'Al momento del pagamento trovi carte di credito e debito, Klarna, Shop Pay, Apple Pay, Google Pay e PayPal. Il contrassegno non \u00e8 disponibile.' },
      { chiavi: ['posa', 'installa', 'montare', 'posare', 'fai da te'], risposta: 'I nostri pavimenti SPC, laminati e ibridi si posano a incastro, senza colla e senza opere murarie. Serve un sottopavimento adeguato: trovi i materassini nella sezione Sottopavimenti.' },
      { chiavi: ['porta', 'porte', 'blindat', 'misura porta', 'apertura'], risposta: 'Le porte interne si configurano per dimensione (da 60x210 a 90x210), apertura battente o scorrevole, senso destro o sinistro, colore e spessore muro. I portoni blindati si configurano su misura: scrivici per la combinazione esatta.' },
      { chiavi: ['bagno', 'cucina', 'umid', 'acqua', 'impermeab'], risposta: 'Per ambienti umidi come bagno e cucina scegli SPC o ibridi, che sono resistenti all\u2019acqua. Il laminato \u00e8 sconsigliato dove ristagna umidit\u00e0. Per i battiscopa, in bagno meglio il PVC.' },
      { chiavi: ['contatt', 'telefono', 'parlare', 'whatsapp', 'email', 'assistenza', 'umano', 'operatore'], risposta: 'Scrivici su <a href="https://wa.me/393513024610" target="_blank" rel="noopener">WhatsApp al 351 3024610</a> oppure a <a href="mailto:casaforma.shop@gmail.com">casaforma.shop@gmail.com</a>. Ti rispondiamo appena possibile.' }
    ];

    const FALLBACK = 'Su questo non ho una risposta pronta. Scrivici su <a href="https://wa.me/393513024610" target="_blank" rel="noopener">WhatsApp al 351 3024610</a> o a <a href="mailto:casaforma.shop@gmail.com">casaforma.shop@gmail.com</a>. Puoi anche usare la ricerca del sito per trovare un prodotto.';

    function rispondi(testo) {
      const t = testo.toLowerCase();
      for (const regola of REGOLE) {
        if (regola.chiavi.some((k) => t.includes(k))) return regola.risposta;
      }
      return FALLBACK;
    }

    function aggiungi(html, mio) {
      const p = document.createElement('p');
      p.className = 'cf-bot__msg ' + (mio ? 'cf-bot__msg--me' : 'cf-bot__msg--bot');
      if (mio) { p.textContent = html; } else { p.innerHTML = html; }
      log.appendChild(p);
      log.scrollTop = log.scrollHeight;
    }

    function chiedi(testo) {
      const pulito = testo.trim();
      if (!pulito) return;
      aggiungi(pulito, true);
      window.setTimeout(function () { aggiungi(rispondi(pulito), false); }, 260);
    }

    function apri(stato) {
      panel.hidden = !stato;
      toggle.setAttribute('aria-expanded', String(stato));
      if (stato) input.focus();
    }

    toggle.addEventListener('click', function () { apri(panel.hidden); });
    closeBtn.addEventListener('click', function () { apri(false); toggle.focus(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); chiedi(input.value); input.value = ''; });
    chips.addEventListener('click', function (e) { const b = e.target.closest('button[data-q]'); if (b) chiedi(b.dataset.q); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { apri(false); toggle.focus(); } });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-commercial-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-commercial-calculator')) {
  customElements.define('cf-commercial-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.closest('form');
      this.addEventListener('input', () => this.update());
      this.abort = new AbortController();
      if (this.form) this.form.addEventListener('submit', event => {
        if (!this.update()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.querySelector('[data-required]').focus();
        }
      }, {capture: true, signal: this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); this.ready = false; }
    update() {
      const requiredInput = this.querySelector('[data-required]');
      const wasteInput = this.querySelector('[data-waste]');
      const required = Number(requiredInput.value);
      const waste = Number(wasteInput.value);
      const coverage = Number(this.dataset.coverage);
      const price = Number(this.dataset.price);
      const valid = requiredInput.value !== '' && wasteInput.value !== '' &&
        Number.isFinite(required) && Number.isFinite(waste) &&
        required > 0 && required <= 100000 && waste >= 0 && waste <= 100 && coverage > 0 && price > 0;
      const out = this.querySelector('output');
      if (!valid) {
        out.textContent = 'Inserisci una quantità positiva e uno sfrido tra 0 e 100%.';
        return false;
      }
      const raw = required * (1 + waste / 100) / coverage;
      const count = Math.ceil(raw - Number.EPSILON * Math.max(1, raw) * 8);
      const number = new Intl.NumberFormat('it-IT', {maximumFractionDigits: 3});
      const money = new Intl.NumberFormat('it-IT', {style:'currency', currency:'EUR'});
      const singular = {confezioni:'confezione',barre:'barra',rotoli:'rotolo',pannelli:'pannello',doghe:'doga'};
      const unitLabel = count === 1 ? (singular[this.dataset.units] || this.dataset.units) : this.dataset.units;
      out.textContent = number.format(count) + ' ' + unitLabel + ' · ' +
        number.format(count * coverage) + ' ' + this.dataset.measure + ' acquistati · ' + money.format(count * price / 100);
      if (this.form) {
        if (this.dataset.variantId) {
          this.form.querySelector('[name="id"]').value = this.dataset.variantId;
          const properties = {'Quantità richiesta inizialmente': number.format(required) + ' ' + this.dataset.measure, 'Misura per unità': number.format(coverage) + ' ' + this.dataset.measure, 'Sfrido': waste + '%'};
          for (const [key, value] of Object.entries(properties)) {
            let input = Array.from(this.form.querySelectorAll('input')).find(i => i.name === 'properties[' + key + ']');
            if (!input) {input = document.createElement('input');input.type='hidden';input.name='properties[' + key + ']';this.form.append(input);}
            input.value=value;
          }
          const button = this.form.querySelector('[name="add"]:not([disabled]) .add-to-cart-text__content');
          if (button) button.textContent = 'Aggiungi ' + count + ' ' + unitLabel + ' al carrello';
        }
        const quantity = this.form.querySelector('[name="quantity"]');
        if (quantity && quantity.value !== String(count)) {
          quantity.value = String(count);
          quantity.dispatchEvent(new Event('change', {bubbles:true}));
        }
      }
      return true;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cf-pack-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-pack-calculator')) {
  customElements.define('cf-pack-calculator', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      this.addEventListener('input',()=>this.update());
    }
    update() {
      const areaInput=this.querySelector('[data-area]');
      const wasteInput=this.querySelector('[data-waste]');
      const out=this.querySelector('output');
      if(areaInput.value===''){out.textContent=this.dataset.empty;return;}
      const area=Number(areaInput.value), waste=Number(wasteInput.value), coverage=Number(this.dataset.coverage);
      if(!Number.isFinite(area)||!Number.isFinite(waste)||area<=0||area>100000||waste<0||waste>30||coverage<=0||wasteInput.value===''){out.textContent=this.dataset.invalid;return;}
      const packs=Math.ceil((area*(1+waste/100)-1e-9)/coverage);
      const format=new Intl.NumberFormat(this.dataset.locale||'it',{maximumFractionDigits:3});
      out.textContent=format.format(packs)+' '+this.dataset.packsLabel+' · '+format.format(packs*coverage)+' '+this.dataset.coverLabel;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
